import { render, staticRenderFns } from "./DeliveryConfigList.vue?vue&type=template&id=a536e90a&"
import script from "./DeliveryConfigList.vue?vue&type=script&lang=js&"
export * from "./DeliveryConfigList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a536e90a')) {
      api.createRecord('a536e90a', component.options)
    } else {
      api.reload('a536e90a', component.options)
    }
    module.hot.accept("./DeliveryConfigList.vue?vue&type=template&id=a536e90a&", function () {
      api.rerender('a536e90a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/store/delivery-config/DeliveryConfigList.vue"
export default component.exports